import { FormikErrors } from 'formik';

import { ILeaveContactsFormValue } from '../types';

export enum ELeaveContactsFormValidationErrors {
  nameRequired = 'Укажите ваше имя',
  phoneRequired = 'Укажите ваш телефон',
  phoneInvalidFormat = 'Неверный формат телефона',
}

export const validateLeaveContactsFormValues = (
  values: ILeaveContactsFormValue,
): FormikErrors<ILeaveContactsFormValue> => {
  const errors: FormikErrors<ILeaveContactsFormValue> = {};

  if (!values.phone) {
    errors.phone = ELeaveContactsFormValidationErrors.phoneRequired;
  } else if (!/\d{10}/.test(values.phone)) {
    errors.phone = ELeaveContactsFormValidationErrors.phoneInvalidFormat;
  }

  if (!values.name) {
    errors.name = ELeaveContactsFormValidationErrors.nameRequired;
  }

  return errors;
};
